// components/pages/SettingsPage.js
import FacebookDisconnectModal from '../modals/FacebookDisconnectModal';
import AutoResponseSettings from '../settings/AutoResponseSettings';
import TrustpilotDisconnectModal from '../modals/TrustpilotDisconnectModal';
import GmailDisconnectModal from '../modals/GmailDisconnectModal';
import G2DisconnectModal from '../modals/G2DisconnectModal';
import CapterraDisconnectModal from '../modals/CapterraDisconnectModal';
import WidgetEmbedModal from '../modals/WidgetEmbedModal';
import widgetService from '../../services/widgetService';
import { CreditCard, TrendingUp, Calendar as CalendarIcon, Package } from 'lucide-react';

import React, { useState, useEffect } from 'react';
import {
  ArrowLeft, Settings, Mail, Clock, FileText, Users,
  Save, CheckCircle, AlertCircle, UserPlus, X, Shield,
  RefreshCw, Plus, Trash2, Edit2, Sparkles, AlertTriangle,
  Star, MessageSquare, MessageCircle, Zap, ChevronRight, Lock
} from 'lucide-react';

// Add this right after your imports and before the main SettingsPage component


const SettingsPage = ({ onBack, user, api, onGmailDisconnected, onNotification }) => {
  const [localNotification, setLocalNotification] = useState(null);
  const [showTrustpilotDisconnectModal, setShowTrustpilotDisconnectModal] = useState(false);
  const [trustpilotReviewCount, setTrustpilotReviewCount] = useState(0);
  const [activeTab, setActiveTab] = useState('general');
  const [settings, setSettings] = useState({});
  const [saving, setSaving] = useState(false);
  const [saveMessage, setSaveMessage] = useState(null);

  // Billing
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [usageData, setUsageData] = useState(null);
  const [billingLoading, setBillingLoading] = useState(false);

  // Gmail specific state
  const [isConnecting, setIsConnecting] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState(null);
  const [gmailError, setGmailError] = useState('');
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [importStatus, setImportStatus] = useState(null);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [showGmailDisconnectModal, setShowGmailDisconnectModal] = useState(false);
  
  // Facebook
  const [facebookStatus, setFacebookStatus] = useState(null);
  const [facebookLoading, setFacebookLoading] = useState(false);
  const [showFacebookDisconnectModal, setShowFacebookDisconnectModal] = useState(false);

  // WhatsApp
  const [whatsappStatus, setWhatsAppStatus] = useState(null);
  const [whatsappLoading, setWhatsAppLoading] = useState(false);
  const [showWhatsAppDisconnectModal, setShowWhatsAppDisconnectModal] = useState(false);

  // Reviews specific state
  const [reviewsStatus, setReviewsStatus] = useState(null);
  const [reviewsLoading, setReviewsLoading] = useState(false);

  // Integration state
  const [activeIntegrations, setActiveIntegrations] = useState({});

  // Team specific state
  const [teamMembers, setTeamMembers] = useState([]);
  const [invitations, setInvitations] = useState([]);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [inviteData, setInviteData] = useState({ email: '', role: 'AGENT', name: '' });
  const [inviteLoading, setInviteLoading] = useState(false);

  // Template specific state
  const [templates, setTemplates] = useState([]);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [isAddingNewTemplate, setIsAddingNewTemplate] = useState(false);
  const [newTemplate, setNewTemplate] = useState({ name: '', content: '' });
  const [isImprovingTemplate, setIsImprovingTemplate] = useState(false);

  // Trustpilot Reviews state
  const [trustpilotStatus, setTrustpilotStatus] = useState(null);
  const [trustpilotDomain, setTrustpilotDomain] = useState('');
  const [verifyingDomain, setVerifyingDomain] = useState(false);
  const [savingDomain, setSavingDomain] = useState(false);
  const [verifyResult, setVerifyResult] = useState(null);

  // G2 state
  const [g2Status, setG2Status] = useState(null);
  const [g2ProductSlug, setG2ProductSlug] = useState('');
  const [verifyingG2, setVerifyingG2] = useState(false);
  const [g2VerifyResult, setG2VerifyResult] = useState(null);
  const [savingG2, setSavingG2] = useState(false);
  const [showG2DisconnectModal, setShowG2DisconnectModal] = useState(false);
  const [g2ReviewCount, setG2ReviewCount] = useState(0);

  // Capterra state
  const [capterraStatus, setCapterraStatus] = useState(null);
  const [capterraProductSlug, setCapterraProductSlug] = useState('');
  const [verifyingCapterra, setVerifyingCapterra] = useState(false);
  const [capterraVerifyResult, setCapterraVerifyResult] = useState(null);
  const [savingCapterra, setSavingCapterra] = useState(false);
  const [showCapterraDisconnectModal, setShowCapterraDisconnectModal] = useState(false);
  const [capterraReviewCount, setCapterraReviewCount] = useState(0);

  // Widget state
  const [widgetStatus, setWidgetStatus] = useState(null);
  const [showWidgetModal, setShowWidgetModal] = useState(false);
  const [widgetSettings, setWidgetSettings] = useState({
    primaryColor: '#7c3aed',
    enabled: false
  });
  const [savingWidgetSettings, setSavingWidgetSettings] = useState(false);

  // Blocked senders state
  const [blockedSenders, setBlockedSenders] = useState([]);
  const [newBlockedEntry, setNewBlockedEntry] = useState('');
  const [savingBlockedSenders, setSavingBlockedSenders] = useState(false);
  const [blockedSendersMessage, setBlockedSendersMessage] = useState(null);

  useEffect(() => {
  if (localNotification) {
    const timer = setTimeout(() => {
      setLocalNotification(null);
    }, 4000);
    return () => clearTimeout(timer);
  }
}, [localNotification]);

useEffect(() => {
  loadSettings();
  loadBlockedSenders();

  checkGmailStatus();
  checkFacebookStatus();
  checkWhatsAppStatus();
  checkTrustpilotStatus();
  checkG2Status();
  checkCapterraStatus();
  checkWidgetStatus();

  if (activeTab === 'team') {
    loadTeamData();
  }
   if (activeTab === 'billing') {
    loadBillingData(); // NEW
  }
  if (activeTab === 'templates') {
    loadTemplates();
  }
    // Load Trustpilot review count when connected
  if (trustpilotStatus?.connected) {
    loadTrustpilotReviewCount();
  }
  if (g2Status?.connected) {
  loadG2ReviewCount();
  }
  if (capterraStatus?.connected) {
    loadCapterraReviewCount();
  }
}, [activeTab, facebookStatus?.connected, trustpilotStatus?.connected, g2Status?.connected, capterraStatus?.connected]);

useEffect(() => {
  const handleMessage = (event) => {
    console.log('[SETTINGS] ===== MESSAGE RECEIVED =====');
    console.log('[SETTINGS] Message type:', event.data?.type);
    console.log('[SETTINGS] Message data:', event.data);
    console.log('[SETTINGS] Message origin:', event.origin);
    console.log('[SETTINGS] Current origin:', window.location.origin);
    console.log('[SETTINGS] ================================');

    if (event.data.type === 'gmail-connected') {
      console.log('[SETTINGS] Gmail message processed');
      if (event.data.success) {
        setConnectionStatus({
          connected: true,
          email: event.data.email
        });
        setIsConnecting(false);
        setGmailError('');
        loadImportStatus();
      } else {
        setGmailError('Failed to connect Gmail account');
        setIsConnecting(false);
      }
    }
    
    if (event.data.type === 'facebook-connected') {
      console.log('[SETTINGS] Facebook message received!', event.data);
      if (event.data.success) {
        console.log('[SETTINGS] Facebook page connected successfully, refreshing status...');
        setTimeout(async () => {
          await checkFacebookStatus();
          setFacebookLoading(false);
          setLocalNotification({
            type: 'success',
            message: 'Facebook page connected successfully!'
          });
          console.log('[SETTINGS] Facebook status refreshed');
        }, 500);
      } else {
        console.error('[SETTINGS] Facebook connection failed:', event.data.error);
        setFacebookLoading(false);
        if (event.data.error && event.data.error !== 'User cancelled') {
          setLocalNotification({
            type: 'error',
            message: event.data.error || 'Failed to connect Facebook'
          });
        }
      }
    }

    if (event.data.type === 'whatsapp-connected') {
      console.log('[SETTINGS] WhatsApp message received!', event.data);
      if (event.data.success) {
        console.log('[SETTINGS] WhatsApp number connected successfully, refreshing status...');
        setTimeout(async () => {
          await checkWhatsAppStatus();
          setWhatsAppLoading(false);
          setLocalNotification({
            type: 'success',
            message: 'WhatsApp number connected successfully!'
          });
          console.log('[SETTINGS] WhatsApp status refreshed');
        }, 500);
      } else {
        console.error('[SETTINGS] WhatsApp connection failed:', event.data.error);
        setWhatsAppLoading(false);
        if (event.data.error && event.data.error !== 'User cancelled') {
          setLocalNotification({
            type: 'error',
            message: event.data.error || 'Failed to connect WhatsApp'
          });
        }
      }
    }
  };

  console.log('[SETTINGS] Message listener attached');
  window.addEventListener('message', handleMessage);
  return () => {
    console.log('[SETTINGS] Message listener removed');
    window.removeEventListener('message', handleMessage);
  };
}, []);

  const loadSettings = async () => {
    try {
      const data = await api.getSettings();
      setSettings(data || {});
    } catch (error) {
      console.error('Error loading settings:', error);
      setSettings({});
    }
  };

  const saveSettings = async () => {
    setSaving(true);
    setSaveMessage(null);
    try {
      await api.updateSettings(settings);
      setSaveMessage({ type: 'success', text: 'Settings saved successfully!' });
      setTimeout(() => setSaveMessage(null), 3000);
    } catch (error) {
      console.error('Error saving settings:', error);
      setSaveMessage({ type: 'error', text: 'Failed to save settings. Please try again.' });
    } finally {
      setSaving(false);
    }
  };

  // Blocked senders functions
  const loadBlockedSenders = async () => {
    try {
      const workspace = api.getCurrentWorkspace();
      if (!workspace?.id) return;
      const data = await api.getBlockedSenders(workspace.id);
      setBlockedSenders(data.blockedSenders || []);
    } catch (error) {
      console.error('Error loading blocked senders:', error);
    }
  };

  const addBlockedSender = async () => {
    const entry = newBlockedEntry.trim().toLowerCase();
    if (!entry) return;
    if (blockedSenders.includes(entry)) {
      setBlockedSendersMessage({ type: 'error', text: 'This entry is already blocked' });
      setTimeout(() => setBlockedSendersMessage(null), 3000);
      return;
    }
    const updated = [...blockedSenders, entry];
    setSavingBlockedSenders(true);
    try {
      const workspace = api.getCurrentWorkspace();
      await api.updateBlockedSenders(workspace.id, updated);
      setBlockedSenders(updated);
      setNewBlockedEntry('');
      setBlockedSendersMessage({ type: 'success', text: 'Sender blocked successfully' });
      setTimeout(() => setBlockedSendersMessage(null), 3000);
    } catch (error) {
      console.error('Error adding blocked sender:', error);
      setBlockedSendersMessage({ type: 'error', text: 'Failed to block sender' });
      setTimeout(() => setBlockedSendersMessage(null), 3000);
    } finally {
      setSavingBlockedSenders(false);
    }
  };

  const removeBlockedSender = async (entry) => {
    const updated = blockedSenders.filter(s => s !== entry);
    setSavingBlockedSenders(true);
    try {
      const workspace = api.getCurrentWorkspace();
      await api.updateBlockedSenders(workspace.id, updated);
      setBlockedSenders(updated);
    } catch (error) {
      console.error('Error removing blocked sender:', error);
    } finally {
      setSavingBlockedSenders(false);
    }
  };

const checkFacebookStatus = async () => {
  try {
    const data = await api.getFacebookStatus?.();
    setFacebookStatus(data);
  } catch (error) {
    console.error('Error checking Facebook status:', error);
    setFacebookStatus({ connected: false, pages: [] });
  }
};

const handleConnectFacebook = async () => {
  setFacebookLoading(true);
  try {
    const response = await api.connectFacebook?.();
    if (response?.authUrl) {
      const width = 700;
      const height = 800;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;

      const popup = window.open(
        response.authUrl,
        'facebook-oauth',
        `width=${width},height=${height},left=${left},top=${top}`
      );

      // Poll for popup close
      const checkInterval = setInterval(async () => {
        if (popup && popup.closed) {
          clearInterval(checkInterval);
          console.log('[SETTINGS] Facebook popup closed');
          // Loading state is managed by postMessage handler
        }
      }, 500);

      // Timeout after 60 seconds
      setTimeout(() => {
        clearInterval(checkInterval);
        setFacebookLoading(false);
      }, 60000);
    }
  } catch (error) {
    console.error('Failed to connect Facebook:', error);
    setFacebookLoading(false);
  }
};
const handleDisconnectFacebook = async () => {
  setFacebookLoading(true);
  try {
    await api.disconnectFacebook?.();
    setFacebookStatus({ connected: false, pages: [] });
    setShowFacebookDisconnectModal(false);
  } catch (error) {
    console.error('Failed to disconnect Facebook:', error);
    alert('Failed to disconnect Facebook pages');
  } finally {
    setFacebookLoading(false);
  }
};

const checkWhatsAppStatus = async () => {
  try {
    const data = await api.getWhatsAppStatus?.();
    setWhatsAppStatus(data);
  } catch (error) {
    console.error('Error checking WhatsApp status:', error);
    setWhatsAppStatus({ connected: false, phoneNumbers: [] });
  }
};

const handleConnectWhatsApp = async () => {
  setWhatsAppLoading(true);
  try {
    const response = await api.connectWhatsApp?.();
    if (response?.authUrl) {
      const width = 700;
      const height = 800;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;

      const popup = window.open(
        response.authUrl,
        'whatsapp-oauth',
        `width=${width},height=${height},left=${left},top=${top}`
      );

      // Monitor popup close
      const checkInterval = setInterval(async () => {
        if (popup && popup.closed) {
          clearInterval(checkInterval);
          console.log('[SETTINGS] WhatsApp popup closed');
          // Loading state is managed by postMessage handler
        }
      }, 500);

      // Timeout after 60 seconds
      setTimeout(() => {
        clearInterval(checkInterval);
        setWhatsAppLoading(false);
      }, 60000);
    }
  } catch (error) {
    console.error('Failed to connect WhatsApp:', error);
    setWhatsAppLoading(false);
  }
};

const handleDisconnectWhatsApp = async () => {
  setWhatsAppLoading(true);
  try {
    await api.disconnectWhatsApp?.();
    setWhatsAppStatus({ connected: false, phoneNumbers: [] });
    setShowWhatsAppDisconnectModal(false);
  } catch (error) {
    console.error('Failed to disconnect WhatsApp:', error);
    alert('Failed to disconnect WhatsApp');
  } finally {
    setWhatsAppLoading(false);
  }
};

const loadBillingData = async () => {
  setBillingLoading(true);
  try {
    const [status, usage] = await Promise.all([
      api.request('/subscription/status'),
      api.getUsage()
    ]);
    setSubscriptionStatus(status);
    setUsageData(usage);
  } catch (error) {
    console.error('Failed to load billing data:', error);
  } finally {
    setBillingLoading(false);
  }
};

const handleOpenBillingPortal = async () => {
  try {
    const response = await api.request('/subscription/create-portal', {
      method: 'POST'
    });
    if (response.url) {
      window.open(response.url, '_blank');
    }
  } catch (error) {
    console.error('Failed to open billing portal:', error);
    setLocalNotification({
      message: 'Failed to open billing portal',
      type: 'error'
    });
  }
};

const handleCancelSubscription = async () => {
  if (!window.confirm('Are you sure you want to cancel your subscription? You will still have access until the end of your billing period.')) {
    return;
  }
  
  try {
    await api.request('/subscription/cancel', { method: 'POST' });
    setLocalNotification({
      message: 'Subscription cancelled. Access continues until period end.',
      type: 'success'
    });
    loadBillingData();
  } catch (error) {
    console.error('Failed to cancel subscription:', error);
    setLocalNotification({
      message: 'Failed to cancel subscription',
      type: 'error'
    });
  }
};

const handleReactivateSubscription = async () => {
  try {
    await api.request('/subscription/reactivate', { method: 'POST' });
    setLocalNotification({
      message: 'Subscription reactivated successfully',
      type: 'success'
    });
    loadBillingData();
  } catch (error) {
    console.error('Failed to reactivate subscription:', error);
    setLocalNotification({
      message: 'Failed to reactivate subscription',
      type: 'error'
    });
  }
};
const handleDisconnectFacebookPage = async (pageId, pageName) => {

  try {
    console.error('🔴 Calling API...');
    await api.disconnectFacebookPage?.(pageId);
    
    console.error('🔴 API call successful, refreshing status...');
    await checkFacebookStatus();
    



      setLocalNotification({
        message: `Disconnected ${pageName || 'Facebook page'}`,
        type: 'success'
      });
    

  } catch (error) {
  
    
 
      setLocalNotification({
        message: 'Failed to disconnect page',
        type: 'error'
      });
    
  }
};

  // Gmail methods
  const checkGmailStatus = async () => {
    try {
      const data = await api.checkGmailStatus();
      setConnectionStatus(data);
      if (data.connected) {
        loadImportStatus();
      }
    } catch (error) {
      console.error('Error checking Gmail status:', error);
    }
  };


  const checkTrustpilotStatus = async () => {
  try {
    const data = await api.getTrustpilotStatus?.();
    setTrustpilotStatus(data);
  } catch (error) {
    console.error('Error checking Trustpilot status:', error);
    setTrustpilotStatus({ connected: false });
  }
};
const loadTrustpilotReviewCount = async () => {
  try {
    // Get reviews filtered by Trustpilot platform
    const reviews = await api.getReviews(null, { platform: 'TRUSTPILOT' });
    setTrustpilotReviewCount(reviews?.length || 0);
  } catch (error) {
    console.error('Error loading Trustpilot review count:', error);
    setTrustpilotReviewCount(0);
  }
};
// REPLACE the Trustpilot handlers in SettingsPage.js
// Find these functions and replace them:

const handleVerifyTrustpilotDomain = async () => {
  if (!trustpilotDomain.trim()) {
   
      setLocalNotification({
        message: 'Please enter a domain',
        type: 'error'
      });
    
    return;
  }

  setVerifyingDomain(true); // Only sets verify loading
  setVerifyResult(null);

  try {
    const result = await api.verifyTrustpilotDomain(trustpilotDomain);
    
    if (result.success) {
      setVerifyResult({
        success: true,
        domain: result.domain,
        companyInfo: result.companyInfo
      });
      
    

      
    }
  } catch (error) {
    setVerifyResult({
      success: false,
      error: error.message || 'Could not verify domain'
    });
    
 
      setLocalNotification({
        message: 'Domain verification failed',
        type: 'error'
      });
    
  } finally {
    setVerifyingDomain(false);
  }
};

const handleSaveTrustpilotDomain = async () => {
  if (!verifyResult?.success) {
  
      setLocalNotification({
        message: 'Please verify the domain first',
        type: 'error'
      });
    
    return;
  }

  setSavingDomain(true); // Only sets save loading

  try {
    await api.updateWorkspaceTrustpilotDomain(verifyResult.domain);
    
    // Reset form
    setTrustpilotDomain('');
    setVerifyResult(null);
    
    // Refresh status
    await checkTrustpilotStatus();
    

      setLocalNotification({
        message: 'Trustpilot connected successfully!',
        type: 'success'
      });
    
  } catch (error) {
   
      setLocalNotification({
        message: 'Failed to save domain: ' + error.message,
        type: 'error'
      });
    
  } finally {
    setSavingDomain(false);
  }
};
  const handleRemoveTrustpilotDomain = async (deleteReviews) => {
    try {
      // Call API with deleteReviews parameter
      const result = await api.removeTrustpilotDomain(deleteReviews);
      
      // Refresh status
      await checkTrustpilotStatus();
      setTrustpilotDomain('');
      setVerifyResult(null);
      setShowTrustpilotDisconnectModal(false);
      
      // Show success notification
      
        const message = deleteReviews 
          ? `Trustpilot disconnected and ${result.deletedReviews || 0} reviews deleted`
          : 'Trustpilot disconnected successfully';
        
        setLocalNotification({
          message,
          type: 'success'
        });
      
    } catch (error) {
      console.error('Error disconnecting Trustpilot:', error);
    
        setLocalNotification({
          message: 'Failed to disconnect Trustpilot: ' + error.message,
          type: 'error'
        });
      
    }
  };
  // G2 handlers
const checkG2Status = async () => {
  try {
    const data = await api.getG2Status?.();
    setG2Status(data);
  } catch (error) {
    console.error('Error checking G2 status:', error);
    setG2Status({ connected: false });
  }
};

const loadG2ReviewCount = async () => {
  try {
    const reviews = await api.getReviews(null, { platform: 'G2' });
    setG2ReviewCount(reviews?.length || 0);
  } catch (error) {
    console.error('Error loading G2 review count:', error);
    setG2ReviewCount(0);
  }
};

const handleVerifyG2Product = async () => {
  if (!g2ProductSlug.trim()) {
    setLocalNotification({
      message: 'Please enter a URL or product slug',
      type: 'error'
    });
    return;
  }

  // Extract slug from full URL if provided
  let slug = g2ProductSlug.trim();
  const urlMatch = slug.match(/g2\.com\/products\/([^\/\?]+)/i);
  if (urlMatch) {
    slug = urlMatch[1];
  }

  setVerifyingG2(true);
  setG2VerifyResult(null);

  try {
    const result = await api.verifyG2Product(slug);
    // ... rest stays same
    
    if (result.success) {
      setG2VerifyResult({
        success: true,
        productSlug: result.productSlug,
        productInfo: result.productInfo
      });
    }
  } catch (error) {
    setG2VerifyResult({
      success: false,
      error: error.message || 'Could not verify product'
    });
    
    setLocalNotification({
      message: 'Product verification failed',
      type: 'error'
    });
  } finally {
    setVerifyingG2(false);
  }
};

const handleSaveG2Product = async () => {
  if (!g2VerifyResult?.success) {
    setLocalNotification({
      message: 'Please verify the product first',
      type: 'error'
    });
    return;
  }

  setSavingG2(true);

  try {
    await api.updateWorkspaceG2Product(g2VerifyResult.productSlug);
    
    setG2ProductSlug('');
    setG2VerifyResult(null);
    
    await checkG2Status();
    
    setLocalNotification({
      message: 'G2 connected successfully!',
      type: 'success'
    });
  } catch (error) {
    setLocalNotification({
      message: 'Failed to save product: ' + error.message,
      type: 'error'
    });
  } finally {
    setSavingG2(false);
  }
};

const handleRemoveG2Product = async (deleteReviews) => {
  try {
    const result = await api.removeG2Product(deleteReviews);
    
    await checkG2Status();
    setG2ProductSlug('');
    setG2VerifyResult(null);
    setShowG2DisconnectModal(false);
    
    const message = deleteReviews 
      ? `G2 disconnected and ${result.deletedReviews || 0} reviews deleted`
      : 'G2 disconnected successfully';
    
    setLocalNotification({
      message,
      type: 'success'
    });
  } catch (error) {
    console.error('Error disconnecting G2:', error);
    setLocalNotification({
      message: 'Failed to disconnect G2: ' + error.message,
      type: 'error'
    });
  }
};

// Capterra handlers
const checkCapterraStatus = async () => {
  try {
    const data = await api.getCapterraStatus?.();
    setCapterraStatus(data);
  } catch (error) {
    console.error('Error checking Capterra status:', error);
    setCapterraStatus({ connected: false });
  }
};

const checkWidgetStatus = async () => {
  try {
    // Widget is always available - just load its settings
    await loadWidgetSettings();
    const settings = await widgetService.getSettings();
    setWidgetStatus({
      available: true,
      apiKey: settings?.apiKey || null
    });
  } catch (error) {
    console.error('Error checking widget status:', error);
    setWidgetStatus({ available: true, apiKey: null });
  }
};

const loadWidgetSettings = async () => {
  try {
    const settings = await widgetService.getSettings();
    setWidgetSettings({
      primaryColor: settings.primaryColor || '#7c3aed',
      enabled: settings.enabled || false
    });
  } catch (error) {
    console.error('Error loading widget settings:', error);
  }
};

const saveWidgetSettings = async () => {
  try {
    setSavingWidgetSettings(true);
    // Only send primaryColor to avoid overwriting other settings like 'enabled'
    await widgetService.updateSettings({ primaryColor: widgetSettings.primaryColor });
    setLocalNotification({ type: 'success', message: 'Widget color saved successfully!' });
  } catch (error) {
    console.error('Error saving widget settings:', error);
    setLocalNotification({ type: 'error', message: 'Failed to save widget settings' });
  } finally {
    setSavingWidgetSettings(false);
  }
};

const loadCapterraReviewCount = async () => {
  try {
    const reviews = await api.getReviews(null, { platform: 'CAPTERRA' });
    setCapterraReviewCount(reviews?.length || 0);
  } catch (error) {
    console.error('Error loading Capterra review count:', error);
    setCapterraReviewCount(0);
  }
};

const handleVerifyCapterraProduct = async () => {
  if (!capterraProductSlug.trim()) {
    setLocalNotification({
      message: 'Please enter a URL or product slug',
      type: 'error'
    });
    return;
  }

  // Extract slug from full URL if provided
  let slug = capterraProductSlug.trim();
  const urlMatch = slug.match(/capterra\.com\/p\/(.+?)(?:\?|$)/i);
  if (urlMatch) {
    slug = urlMatch[1].replace(/\/$/, ''); // Remove trailing slash
  }

  setVerifyingCapterra(true);
  setCapterraVerifyResult(null);

  try {
    const result = await api.verifyCapterraProduct(slug);
    // ... rest stays same
    
    if (result.success) {
      setCapterraVerifyResult({
        success: true,
        productSlug: result.productSlug,
        productInfo: result.productInfo
      });
    }
  } catch (error) {
    setCapterraVerifyResult({
      success: false,
      error: error.message || 'Could not verify product'
    });
    
    setLocalNotification({
      message: 'Product verification failed',
      type: 'error'
    });
  } finally {
    setVerifyingCapterra(false);
  }
};

const handleSaveCapterraProduct = async () => {
  if (!capterraVerifyResult?.success) {
    setLocalNotification({
      message: 'Please verify the product first',
      type: 'error'
    });
    return;
  }

  setSavingCapterra(true);

  try {
    await api.updateWorkspaceCapterraProduct(capterraVerifyResult.productSlug);
    
    setCapterraProductSlug('');
    setCapterraVerifyResult(null);
    
    await checkCapterraStatus();
    
    setLocalNotification({
      message: 'Capterra connected successfully!',
      type: 'success'
    });
  } catch (error) {
    setLocalNotification({
      message: 'Failed to save product: ' + error.message,
      type: 'error'
    });
  } finally {
    setSavingCapterra(false);
  }
};

const handleRemoveCapterraProduct = async (deleteReviews) => {
  try {
    const result = await api.removeCapterraProduct(deleteReviews);
    
    await checkCapterraStatus();
    setCapterraProductSlug('');
    setCapterraVerifyResult(null);
    setShowCapterraDisconnectModal(false);
    
    const message = deleteReviews 
      ? `Capterra disconnected and ${result.deletedReviews || 0} reviews deleted`
      : 'Capterra disconnected successfully';
    
    setLocalNotification({
      message,
      type: 'success'
    });
  } catch (error) {
    console.error('Error disconnecting Capterra:', error);
    setLocalNotification({
      message: 'Failed to disconnect Capterra: ' + error.message,
      type: 'error'
    });
  }
};
  const loadImportStatus = async () => {
    if (!connectionStatus?.connected) return;
    
    setLoadingStatus(true);
    try {
      const status = await api.getGmailImportStatus();
      const processedStatus = {
        lastScanTime: status?.lastScanTime || null,
        totalImported: status?.totalImported || 0,
        lastImportCount: status?.lastImportCount || 0,
        importFrequency: status?.importFrequency || 5,
        importStatus: status?.importStatus || 'never_run'
      };
      setImportStatus(processedStatus);
    } catch (error) {
      console.error('ERROR loading import status:', error);
      setImportStatus({
        lastScanTime: null,
        totalImported: 0,
        lastImportCount: 0,
        importFrequency: 5,
        importStatus: 'never_run'
      });
    } finally {
      setLoadingStatus(false);
    }
  };

  const handleConnectGmail = async () => {
    setIsConnecting(true);
    setGmailError('');

    try {
      const data = await api.connectGmail();
      if (data.authUrl || data.auth_url || data.url) {
        const authUrl = data.authUrl || data.auth_url || data.url;
        
        const width = 500;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        
        const popup = window.open(
          authUrl,
          'gmail-oauth',
          `width=${width},height=${height},left=${left},top=${top}`
        );

        if (!popup || popup.closed) {
          setGmailError('Please allow popups for Gmail authentication');
          setIsConnecting(false);
        }
      } else {
        setGmailError(data.error || data.message || 'Failed to initiate Gmail connection');
        setIsConnecting(false);
      }
    } catch (error) {
      console.error('Connection error:', error);
      setGmailError('Failed to connect to Gmail. Please check the server configuration.');
      setIsConnecting(false);
    }
  };



  const handleDisconnectGmailClick = () => {
    setShowGmailDisconnectModal(true);
  };

  const handleDisconnectGmailConfirm = async () => {
    setIsDisconnecting(true);
    try {
      await api.disconnectGmail();
      setConnectionStatus({ connected: false });
      setImportStatus(null);
      setGmailError('');
      setShowGmailDisconnectModal(false);
      
      if (onGmailDisconnected) {
        onGmailDisconnected();
      }
    } catch (error) {
      console.error('Disconnect error:', error);
      setGmailError('Failed to disconnect Gmail');
    } finally {
      setIsDisconnecting(false);
    }
  };

  const formatLastScanTime = (timestamp) => {
    if (!timestamp) return 'Never';
    
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
    if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    
    return date.toLocaleDateString() + ' at ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  // Team methods (unchanged)
  const loadTeamData = async () => {
    try {
      const response = await api.getTeamMembers();
      if (response) {
        setTeamMembers(response.members || []);
        setInvitations(response.invitations || []);
      }
    } catch (error) {
      console.error('Error loading team data:', error);
    }
  };

  const handleInvite = async () => {
    setInviteLoading(true);
    try {
      await api.inviteTeamMember(inviteData.email, inviteData.role, inviteData.name);
      setShowInviteModal(false);
      setInviteData({ email: '', role: 'AGENT', name: '' });
      loadTeamData();
    } catch (error) {
      console.error('Error sending invitation:', error);
      alert('Failed to send invitation. Please try again.');
    } finally {
      setInviteLoading(false);
    }
  };

  const handleResendInvite = async (inviteId) => {
    try {
      await api.resendInvitation(inviteId);
      alert('Invitation resent successfully');
      loadTeamData();
    } catch (error) {
      console.error('Error resending invitation:', error);
      alert('Failed to resend invitation');
    }
  };

  const handleRevokeInvite = async (inviteId) => {
    if (window.confirm('Are you sure you want to revoke this invitation?')) {
      try {
        await api.revokeInvitation(inviteId);
        loadTeamData();
      } catch (error) {
        console.error('Error revoking invitation:', error);
        alert('Failed to revoke invitation');
      }
    }
  };

  const handleRemoveMember = async (userId) => {
    if (window.confirm('Are you sure you want to remove this team member? This action cannot be undone.')) {
      try {
        await api.removeTeamMember(userId);
        loadTeamData();
      } catch (error) {
        console.error('Error removing team member:', error);
        alert('Failed to remove team member');
      }
    }
  };

  const getRoleBadgeColor = (role) => {
    switch (role) {
      case 'ADMIN': return 'bg-purple-100 text-purple-800';
      case 'MANAGER': return 'bg-blue-100 text-blue-800';
      case 'AGENT': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  // Template methods (unchanged)
  const loadTemplates = async () => {
    try {
      const data = await api.getResponseTemplates();
      setTemplates(data || []);
    } catch (error) {
      console.error('Error loading templates:', error);
    }
  };

  const handleSaveTemplate = async (template) => {
    try {
      if (template.id) {
        await api.updateResponseTemplate(template.id, template);
      } else {
        await api.saveResponseTemplate(template);
      }
      loadTemplates();
      setEditingTemplate(null);
      setIsAddingNewTemplate(false);
      setNewTemplate({ name: '', content: '' });
    } catch (error) {
      console.error('Error saving template:', error);
    }
  };

  const handleDeleteTemplate = async (id) => {
    if (window.confirm('Are you sure you want to delete this template?')) {
      try {
        await api.deleteResponseTemplate(id);
        loadTemplates();
      } catch (error) {
        console.error('Error deleting template:', error);
      }
    }
  };

  const handleImproveTemplate = async (template) => {
    setIsImprovingTemplate(true);
    try {
      const response = await api.improveTemplate(template);
      
      if (response.success && response.improvedContent) {
        const updatedTemplate = { 
          ...template, 
          content: response.improvedContent 
        };
        setEditingTemplate(updatedTemplate);
        return;
      }
      
      throw new Error(response.error || 'AI improvement failed');
      
    } catch (error) {
      let improvedContent = template.content;
      
      if (!improvedContent.includes('{customerFirstName}') && !improvedContent.includes('{customerName}')) {
        improvedContent = `Dear {customerFirstName},\n\n${improvedContent}`;
      }
      
      if (!improvedContent.includes('{agentName}') && !improvedContent.includes('Best regards')) {
        improvedContent = `${improvedContent}\n\nBest regards,\n{agentName}\nCustomer Service Team`;
      }
      
      if (!improvedContent.includes('{subject}') && improvedContent.length > 100) {
        improvedContent = improvedContent.replace(
          'Thank you for contacting us',
          'Thank you for contacting us regarding "{subject}"'
        );
      }
      
      improvedContent = improvedContent
        .replace(/\s+([.,!?])/g, '$1')
        .replace(/([.,!?])([A-Za-z])/g, '$1 $2')
        .replace(/([.!?])\s*\n\s*([A-Z])/g, '$1\n\n$2')
        .replace(/\n{3,}/g, '\n\n')
        .replace(/\. ([a-z])/g, (match, p1) => `. ${p1.toUpperCase()}`)
        .replace(/\bwe will\b/gi, "we'll")
        .replace(/\byou will\b/gi, "you'll")
        .replace(/\bdo not\b/gi, "don't")
        .replace(/\bcannot\b/gi, "can't")
        .replace(/\bwe are\b/gi, "we're")
        .replace(/\bSorry\b/g, "We sincerely apologize")
        .replace(/\bthanks\b/gi, "thank you")
        .replace(/\bhi\b/gi, "Hello")
        .replace(/\bbye\b/gi, "Best regards")
        .trim();
      
      if (!improvedContent.includes('{complaintId}') && template.category === 'escalation') {
        improvedContent = improvedContent.replace(
          'has been escalated',
          'has been escalated (Ticket #{complaintId})'
        );
      }
      
      setEditingTemplate({ ...template, content: improvedContent });
    } finally {
      setIsImprovingTemplate(false);
    }
  };

  // Define all integrations
// Use useMemo to recalculate when statuses change
const integrations = React.useMemo(() => {

  return [
  {
    id: 'gmail',
    name: 'Gmail Tickets',
    description: 'Import customer tickets from Gmail automatically',
    icon: Mail,
    status: connectionStatus?.connected ? 'connected' : 'disconnected',
    color: 'bg-red-500',
    implemented: true,
    category: 'Email'
  },
  
  {
    id: 'facebook',
    name: 'Facebook',
    description: 'Handle Facebook page messages and comments',
    icon: MessageSquare,
    status: facebookStatus?.connected ? 'connected' : 'disconnected',
    color: 'bg-blue-600',
    implemented: true,
    category: 'Social Media'
  },
    {
      id: 'whatsapp',
      name: 'WhatsApp Business',
      description: 'Handle WhatsApp Business messages',
      icon: MessageCircle,
      status: whatsappStatus?.connected ? 'connected' : 'disconnected',
      color: 'bg-green-500',
      implemented: true,
      category: 'Social Media'
    },
    {
      id: 'trustpilot',
      name: 'Trustpilot Reviews',
      description: 'Monitor and respond to Trustpilot reviews',
      icon: Star,
      status: trustpilotStatus?.connected ? 'connected' : 'disconnected',
      color: 'bg-teal-600',
      implemented: true,
      category: 'Reviews'
    }
    ,

{
  id: 'capterra',
  name: 'Capterra',
  description: 'Handle software marketplace reviews',
  icon: TrendingUp,
  status: capterraStatus?.connected ? 'connected' : 'disconnected',
  color: 'bg-blue-500',
  implemented: true,
  category: 'Reviews'
},
{
  id: 'widget',
  name: 'Chat Widget',
  description: 'Embed a chat widget on your website',
  icon: MessageCircle,
  status: 'available', // Widget is always available
  color: 'bg-purple-600',
  implemented: true,
  category: 'Chat'
}
      ];}, [connectionStatus?.connected, reviewsStatus?.connected, facebookStatus?.connected, trustpilotStatus?.connected, g2Status?.connected, capterraStatus?.connected]);

  const groupedIntegrations = integrations.reduce((acc, integration) => {
    if (!acc[integration.category]) {
      acc[integration.category] = [];
    }
    acc[integration.category].push(integration);
    return acc;
  }, {});

  const getStatusBadge = (status) => {
    switch (status) {
      case 'connected':
        return <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">Connected</span>;
      case 'disconnected':
        return <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full">Not Connected</span>;
      case 'coming-soon':
        return <span className="px-2 py-1 bg-amber-100 text-amber-700 text-xs font-medium rounded-full">Coming Soon</span>;
      case 'available':
        return null; // Widget is always available, no status badge needed
      default:
        return null;
    }
  };

const renderIntegrationDetails = (integration) => {

if (integration.id === 'g2') {
  return (
    <div className="space-y-4">
      {g2Status?.connected ? (
        <>
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2" />
                  <span className="font-medium text-green-900">G2 Connected</span>
                </div>
                <p className="text-sm text-green-700 mt-1">
                  Product: {g2Status.productSlug}
                </p>
                
                  <a href={`https://www.g2.com/products/${g2Status.productSlug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-green-600 hover:underline mt-1 inline-flex items-center"
                >
                  View on G2
                  <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
              <button
                onClick={() => setShowG2DisconnectModal(true)}
                className="px-3 py-1 text-sm border border-red-300 text-red-700 rounded hover:bg-red-50"
              >
                Disconnect
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="space-y-4">
 <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
  <h4 className="font-semibold text-blue-900 mb-2 text-sm">Find Your G2 Product Slug</h4>
  <ol className="text-xs text-blue-800 space-y-1">
    <li>1. Go to <a href="https://www.g2.com" target="_blank" rel="noopener noreferrer" className="underline">G2.com</a> and search for your product</li>
    <li>2. Open your product page - the URL looks like: g2.com/products/your-product-name/reviews</li>
    <li>3. Copy just the product name part - example: <code className="bg-blue-100 px-1 rounded">your-product-name</code></li>
    <li>4. Paste it below to connect</li>
  </ol>
</div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              G2 Product Slug
            </label>
            <div className="flex gap-2">
              <input
                type="text"
                value={g2ProductSlug}
                onChange={(e) => {
                  setG2ProductSlug(e.target.value);
                  setG2VerifyResult(null);
                }}
                placeholder="e.g., yourproduct"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-purple-500"
                disabled={verifyingG2 || savingG2}
              />
              <button
                onClick={handleVerifyG2Product}
                disabled={verifyingG2 || savingG2 || !g2ProductSlug.trim()}
                className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 min-w-[100px] justify-center"
              >
                {verifyingG2 ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    <span>Verifying...</span>
                  </>
                ) : (
                  'Verify'
                )}
              </button>
            </div>
          </div>

          {g2VerifyResult && (
            <div className={`p-3 rounded-md border ${
              g2VerifyResult.success 
                ? 'bg-green-50 border-green-200' 
                : 'bg-red-50 border-red-200'
            }`}>
              {g2VerifyResult.success ? (
                <div>
                  <p className="text-sm font-medium text-green-900">
                    ✓ Found: {g2VerifyResult.productInfo.name}
                  </p>
                  <button
                    onClick={handleSaveG2Product}
                    disabled={savingG2 || verifyingG2}
                    className="mt-3 w-full px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {savingG2 ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                        <span>Connecting...</span>
                      </>
                    ) : (
                      'Save & Connect'
                    )}
                  </button>
                </div>
              ) : (
                <p className="text-sm text-red-900">{g2VerifyResult.error}</p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

if (integration.id === 'capterra') {
  return (
    <div className="space-y-4">
      {capterraStatus?.connected ? (
        <>
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2" />
                  <span className="font-medium text-green-900">Capterra Connected</span>
                </div>
                <p className="text-sm text-green-700 mt-1">
                  Product: {capterraStatus.productSlug}
                </p>
                
                  <a href={`https://www.capterra.com/p/${capterraStatus.productSlug}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-green-600 hover:underline mt-1 inline-flex items-center"
                >
                  View on Capterra
                  <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
              <button
                onClick={() => setShowCapterraDisconnectModal(true)}
                className="px-3 py-1 text-sm border border-red-300 text-red-700 rounded hover:bg-red-50"
              >
                Disconnect
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="space-y-4">
<div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
  <h4 className="font-semibold text-blue-900 mb-2 text-sm">Connect Your Capterra Product</h4>
  <ol className="text-xs text-blue-800 space-y-1">
    <li>1. Go to your Capterra product page</li>
    <li>2. Copy the full URL from your browser</li>
    <li>3. Paste it below - we'll extract what we need automatically</li>
  </ol>
  <p className="text-xs text-blue-700 mt-2">
    Example: <code className="bg-blue-100 px-1 rounded">https://www.capterra.com/p/123456/product-name</code>
  </p>
</div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Capterra Product Slug
            </label>
            <div className="flex gap-2">
              <input
                type="text"
                value={capterraProductSlug}
                onChange={(e) => {
                  setCapterraProductSlug(e.target.value);
                  setCapterraVerifyResult(null);
                }}
                placeholder="e.g., yourproduct"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-purple-500"
                disabled={verifyingCapterra || savingCapterra}
              />
              <button
                onClick={handleVerifyCapterraProduct}
                disabled={verifyingCapterra || savingCapterra || !capterraProductSlug.trim()}
                className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 min-w-[100px] justify-center"
              >
                {verifyingCapterra ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    <span>Verifying...</span>
                  </>
                ) : (
                  'Verify'
                )}
              </button>
            </div>
          </div>

          {capterraVerifyResult && (
            <div className={`p-3 rounded-md border ${
              capterraVerifyResult.success 
                ? 'bg-green-50 border-green-200' 
                : 'bg-red-50 border-red-200'
            }`}>
              {capterraVerifyResult.success ? (
                <div>
                  <p className="text-sm font-medium text-green-900">
                    ✓ Found: {capterraVerifyResult.productInfo.productName}
                    </p>
                    <p className="text-xs text-green-700 mt-1">
                      {capterraVerifyResult.productInfo.averageRating}/5 rating • {capterraVerifyResult.productInfo.totalReviews} reviews
                    </p>
                  <button
                    onClick={handleSaveCapterraProduct}
                    disabled={savingCapterra || verifyingCapterra}
                    className="mt-3 w-full px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {savingCapterra ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                        <span>Connecting...</span>
                      </>
                    ) : (
                      'Save & Connect'
                    )}
                  </button>
                </div>
              ) : (
                <p className="text-sm text-red-900">{capterraVerifyResult.error}</p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

if (integration.id === 'trustpilot') {
  return (
    <div className="space-y-4">
      {trustpilotStatus?.connected ? (
        <>
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2" />
                  <span className="font-medium text-green-900">Trustpilot Connected</span>
                </div>
                <p className="text-sm text-green-700 mt-1">
                  Domain: {trustpilotStatus.domain}
                </p>
                <a
                  href={`https://www.trustpilot.com/review/${trustpilotStatus.domain}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-green-600 hover:underline mt-1 inline-flex items-center"
                >
                  View on Trustpilot
                  <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </svg>
                </a>
              </div>
              <button
                onClick={() => setShowTrustpilotDisconnectModal(true)}
                className="px-3 py-1 text-sm border border-red-300 text-red-700 rounded hover:bg-red-50"
              >
                Disconnect
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-semibold text-blue-900 mb-2 text-sm">Find Your Trustpilot Domain</h4>
            <ol className="text-xs text-blue-800 space-y-1">
              <li>1. Go to your Trustpilot page (e.g., trustpilot.com/review/yourcompany.com)</li>
              <li>2. Copy the domain after "/review/" (e.g., "yourcompany.com")</li>
              <li>3. Enter it below to verify</li>
            </ol>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Trustpilot Domain
            </label>
            <div className="flex gap-2">
              <input
                type="text"
                value={trustpilotDomain}
                onChange={(e) => {
                  setTrustpilotDomain(e.target.value);
                  setVerifyResult(null);
                }}
                placeholder="e.g., yourcompany.com"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-purple-500"
                disabled={verifyingDomain || savingDomain}
              />
              <button
                onClick={handleVerifyTrustpilotDomain}
                disabled={verifyingDomain || savingDomain || !trustpilotDomain.trim()}
                className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 min-w-[100px] justify-center"
              >
                {verifyingDomain ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    <span>Verifying...</span>
                  </>
                ) : (
                  'Verify'
                )}
              </button>
            </div>
          </div>

          {verifyResult && (
            <div className={`p-3 rounded-md border ${
              verifyResult.success 
                ? 'bg-green-50 border-green-200' 
                : 'bg-red-50 border-red-200'
            }`}>
              {verifyResult.success ? (
                <div>
                  <p className="text-sm font-medium text-green-900">
                    ✓ Found: {verifyResult.companyInfo.companyName}
                  </p>
                  <p className="text-xs text-green-700 mt-1">
                    Trust Score: {verifyResult.companyInfo.trustScore}/5 • {verifyResult.companyInfo.totalReviews} reviews
                  </p>
                  <button
                    onClick={handleSaveTrustpilotDomain}
                    disabled={savingDomain || verifyingDomain}
                    className="mt-3 w-full px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                  >
                    {savingDomain ? (
                      <>
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                        <span>Connecting...</span>
                      </>
                    ) : (
                      'Save & Connect'
                    )}
                  </button>
                </div>
              ) : (
                <p className="text-sm text-red-900">{verifyResult.error}</p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
  if (integration.id === 'gmail') {
    return (
      <div className="space-y-4">
        {connectionStatus?.connected ? (
          <>
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <div className="flex items-start justify-between">
                <div>
                  <div className="flex items-center">
                    <CheckCircle className="h-5 w-5 text-green-600 mr-2" />
                    <span className="font-medium text-green-900">Gmail Connected</span>
                  </div>
                  <p className="text-sm text-green-700 mt-1">
                    Connected to: {connectionStatus.email}
                  </p>
                  {connectionStatus.lastSync && (
                    <p className="text-xs text-green-600 mt-1">
                      Last sync: {new Date(connectionStatus.lastSync).toLocaleString()}
                    </p>
                  )}
                </div>
                <button
                  onClick={handleDisconnectGmailClick}
                  disabled={isDisconnecting}
                  className="px-3 py-1 text-sm border border-red-300 text-red-700 rounded hover:bg-red-50 disabled:opacity-50"
                >
                  {isDisconnecting ? 'Disconnecting...' : 'Disconnect'}
                </button>
              </div>
            </div>

            {importStatus && (
              <div className="grid grid-cols-3 gap-4">
                <div className="text-center p-3 bg-white border rounded-lg">
                  <div className="text-2xl font-bold text-purple-600">{importStatus.totalImported || 0}</div>
                  <div className="text-xs text-gray-500">Total Imported</div>
                </div>
                <div className="text-center p-3 bg-white border rounded-lg">
                  <div className="text-2xl font-bold text-blue-600">{importStatus.lastImportCount || 0}</div>
                  <div className="text-xs text-gray-500">Last Import</div>
                </div>
                <div className="text-center p-3 bg-white border rounded-lg">
                  <div className="text-2xl font-bold text-green-600">{importStatus.importFrequency || 5}m</div>
                  <div className="text-xs text-gray-500">Sync Frequency</div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="text-center">
            <Mail className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Connect Gmail</h3>
            <p className="text-sm text-gray-500 mb-4">
              Automatically import customer tickets from your Gmail account
            </p>
            <button
              onClick={handleConnectGmail}
              disabled={isConnecting}
              className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
            >
              {isConnecting ? 'Connecting...' : 'Connect Gmail Account'}
            </button>
          </div>
        )}
      </div>
    );
  }
  

  
  if (integration.id === 'facebook') {
    return (
      <div className="space-y-4">
        {facebookStatus?.connected && facebookStatus?.pages?.length > 0 ? (
          <>
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <div className="flex items-center">
                <CheckCircle className="w-5 h-5 text-green-600 mr-3" />
                <div>
                  <p className="font-medium text-gray-900">Facebook Pages Connected</p>
                  <p className="text-sm text-gray-600">{facebookStatus.pages.length} page(s) connected</p>
                </div>
              </div>
            </div>

            <div className="space-y-2">
              {facebookStatus.pages.map((page) => (
                <div key={page.id} className="bg-white border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      {page.pictureUrl && (
                        <img 
                          src={page.pictureUrl} 
                          alt={page.name}
                          className="w-10 h-10 rounded-full"
                        />
                      )}
                      <div>
                        <p className="font-medium text-gray-900">{page.name}</p>
                        <p className="text-xs text-gray-500">{page.category}</p>
                        {page.isWebhooksSubscribed && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 mt-1">
                            Webhooks Active
                          </span>
                        )}
                      </div>
                    </div>
            
                  </div>
                </div>
              ))}
            </div>

              <button
            onClick={() => setShowFacebookDisconnectModal(true)}
            disabled={facebookLoading}
            className="w-full px-4 py-2 border border-red-300 text-red-700 rounded-lg hover:bg-red-50 disabled:opacity-50"
          >
            Disconnect
          </button>
          </>
        ) : (
          <div className="text-center">
            <MessageSquare className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Connect Facebook Pages</h3>
            <p className="text-sm text-gray-500 mb-4">
              Automatically convert Facebook Messenger conversations into support tickets
            </p>
            <button
              onClick={handleConnectFacebook}
              disabled={facebookLoading}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
            >
              {facebookLoading ? 'Connecting...' : 'Connect Facebook Pages'}
            </button>
          </div>
        )}
      </div>
    );
  }

  if (integration.id === 'whatsapp') {
    return (
      <div className="space-y-4">
        {whatsappStatus?.connected && whatsappStatus?.phoneNumbers?.length > 0 ? (
          <>
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <div className="flex items-center">
                <CheckCircle className="w-5 h-5 text-green-600 mr-3" />
                <div>
                  <p className="font-medium text-gray-900">WhatsApp Number Connected</p>
                  <p className="text-sm text-gray-600">{whatsappStatus.phoneNumbers.length} phone number(s) connected</p>
                </div>
              </div>
            </div>

            <div className="space-y-2">
              {whatsappStatus.phoneNumbers.map((phone) => (
                <div key={phone.id} className="bg-white border border-gray-200 rounded-lg p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                        <MessageCircle className="w-6 h-6 text-green-600" />
                      </div>
                      <div>
                        <p className="font-medium text-gray-900">{phone.phoneNumber}</p>
                        <p className="text-xs text-gray-500">{phone.displayName}</p>
                        {phone.verifiedName && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 mt-1">
                            ✓ Verified: {phone.verifiedName}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => setShowWhatsAppDisconnectModal(true)}
              disabled={whatsappLoading}
              className="w-full px-4 py-2 border border-red-300 text-red-700 rounded-lg hover:bg-red-50 disabled:opacity-50"
            >
              Disconnect
            </button>
          </>
        ) : (
          <div className="text-center">
            <MessageCircle className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Connect WhatsApp Business</h3>
            <p className="text-sm text-gray-500 mb-4">
              Automatically convert WhatsApp Business conversations into support tickets
            </p>
            <button
              onClick={handleConnectWhatsApp}
              disabled={whatsappLoading}
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50"
            >
              {whatsappLoading ? 'Connecting...' : 'Connect WhatsApp Business'}
            </button>
          </div>
        )}
      </div>
    );
  }

  if (integration.id === 'widget') {
    return (
      <div className="space-y-4">
        {/* Widget is always available - no connection status needed */}
        <div className="space-y-4">
          {/* Color Picker */}
          <div className="bg-white border border-gray-200 rounded-lg p-4">
            <label className="block text-sm font-medium text-gray-900 mb-3">
              Widget Color
            </label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                value={widgetSettings.primaryColor}
                onChange={(e) => setWidgetSettings(prev => ({ ...prev, primaryColor: e.target.value }))}
                className="h-10 w-16 rounded border border-gray-300 cursor-pointer"
              />
              <input
                type="text"
                value={widgetSettings.primaryColor}
                onChange={(e) => setWidgetSettings(prev => ({ ...prev, primaryColor: e.target.value }))}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                placeholder="#7c3aed"
              />
              <button
                onClick={saveWidgetSettings}
                disabled={savingWidgetSettings}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 flex items-center gap-2"
              >
                {savingWidgetSettings ? (
                  <>
                    <RefreshCw className="w-4 h-4 animate-spin" />
                    Saving...
                  </>
                ) : (
                  <>
                    <Save className="w-4 h-4" />
                    Save
                  </>
                )}
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              This color will be applied to the widget button, header, and buttons
            </p>
          </div>

          <button
            onClick={() => setShowWidgetModal(true)}
            className="w-full px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center justify-center gap-2"
          >
            <MessageCircle className="w-4 h-4" />
            View Installation Code
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center py-8">
      <integration.icon className="w-12 h-12 text-gray-300 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">{integration.name} Integration</h3>
      <p className="text-sm text-gray-500 mb-4">{integration.description}</p>
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <p className="text-sm text-amber-800">
          <span className="font-medium">Coming Soon!</span> This integration is currently in development. 
          We'll notify you when it becomes available.
        </p>
      </div>
    </div>
  );
};
    const tabs = [
      { id: 'general', label: 'Notifications', icon: Settings, description: 'Configure your notification preferences' },
      { id: 'integrations', label: 'Integrations', icon: Zap, description: 'Connect your platforms and tools' },
      { id: 'billing', label: 'Billing & Plans', icon: CreditCard, description: 'Manage subscription and usage' }, // NEW TAB
      { id: 'autoresponse', label: 'Auto-Responses', icon: MessageCircle, description: 'Configure automatic replies' },
      { id: 'business', label: 'Business Hours', icon: Clock, description: 'Set your availability' },
      { id: 'templates', label: 'Templates', icon: FileText, description: 'Manage response templates' },
      { id: 'team', label: 'Team', icon: Users, description: 'Manage team members and roles' }
    ];

  const DEFAULT_HOURS = {
    monday: { enabled: true, open: '09:00', close: '17:00' },
    tuesday: { enabled: true, open: '09:00', close: '17:00' },
    wednesday: { enabled: true, open: '09:00', close: '17:00' },
    thursday: { enabled: true, open: '09:00', close: '17:00' },
    friday: { enabled: true, open: '09:00', close: '17:00' },
    saturday: { enabled: false, open: '09:00', close: '17:00' },
    sunday: { enabled: false, open: '09:00', close: '17:00' }
  };

  const businessHours = settings.businessHours || DEFAULT_HOURS;

  const handleDayToggle = (day) => {
    const updatedHours = {
      ...businessHours,
      [day]: {
        ...businessHours[day],
        enabled: !businessHours[day].enabled
      }
    };
    setSettings({ ...settings, businessHours: updatedHours });
  };

  const handleTimeChange = (day, field, value) => {
    const updatedHours = {
      ...businessHours,
      [day]: {
        ...businessHours[day],
        [field]: value
      }
    };
    setSettings({ ...settings, businessHours: updatedHours });
  };

  const applyToAllWeekdays = () => {
    const mondayHours = businessHours.monday;
    const newHours = { ...businessHours };
    ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'].forEach(day => {
      newHours[day] = { ...mondayHours };
    });
    setSettings({ ...settings, businessHours: newHours });
  };

  const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'billing':
  if (billingLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <RefreshCw className="h-8 w-8 animate-spin text-purple-600" />
      </div>
    );
  }

  const planNames = {
    FREE: 'Free',
    STARTER: 'Starter',
    GROWTH: 'Growth',
    SCALE: 'Scale',
    ENTERPRISE: 'Enterprise'
  };

  const planColors = {
    FREE: 'bg-gray-100 text-gray-800',
    STARTER: 'bg-blue-100 text-blue-800',
    GROWTH: 'bg-purple-100 text-purple-800',
    SCALE: 'bg-yellow-100 text-yellow-800',
    ENTERPRISE: 'bg-green-100 text-green-800'
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Billing & Subscription</h2>
        <p className="text-sm text-gray-600 mb-6">
          Manage your subscription, view usage, and update payment methods
        </p>
      </div>

      {/* Current Plan */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="text-md font-medium text-gray-900 flex items-center gap-2">
              <Package className="h-5 w-5 text-gray-400" />
              Current Plan
            </h3>
          </div>
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${
            planColors[subscriptionStatus?.plan] || 'bg-gray-100 text-gray-800'
          }`}>
            {planNames[subscriptionStatus?.plan] || 'Free'}
          </span>
        </div>

        <div className="space-y-3">
          {subscriptionStatus?.status === 'active' && subscriptionStatus?.plan !== 'FREE' && (
            <>
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Billing Cycle</span>
                <span className="font-medium text-gray-900">
                  {subscriptionStatus.billingInterval === 'year' ? 'Annual' : 'Monthly'}
                </span>
              </div>
              
              {subscriptionStatus.currentPeriodEnd && (
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Next Billing Date</span>
                  <span className="font-medium text-gray-900">
                    {new Date(subscriptionStatus.currentPeriodEnd).toLocaleDateString()}
                  </span>
                </div>
              )}

              {subscriptionStatus.cancelAtPeriodEnd && (
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mt-4">
                  <div className="flex items-start gap-2">
                    <AlertTriangle className="h-5 w-5 text-amber-600 mt-0.5" />
                    <div>
                      <p className="text-sm font-medium text-amber-900">
                        Subscription Cancelled
                      </p>
                      <p className="text-xs text-amber-700 mt-1">
                        Your subscription will end on {new Date(subscriptionStatus.currentPeriodEnd).toLocaleDateString()}. 
                        You'll still have access until then.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {subscriptionStatus?.trialEnd && new Date(subscriptionStatus.trialEnd) > new Date() && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-3">
              <div className="flex items-center gap-2">
                <CheckCircle className="h-5 w-5 text-green-600" />
                <div>
                  <p className="text-sm font-medium text-green-900">Trial Active</p>
                  <p className="text-xs text-green-700">
                    Ends {new Date(subscriptionStatus.trialEnd).toLocaleDateString()}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Usage Stats */}
      {usageData && (
        <div className="bg-white border border-gray-200 rounded-lg p-6">
          <h3 className="text-md font-medium text-gray-900 flex items-center gap-2 mb-4">
            <TrendingUp className="h-5 w-5 text-gray-400" />
            Usage This Month
          </h3>
          
          <div className="space-y-4">
            <div>
              <div className="flex justify-between text-sm mb-2">
                <span className="text-gray-600">Tickets Used</span>
                <span className="font-medium text-gray-900">
                  {usageData.used} / {usageData.limit === -1 ? '∞' : usageData.limit}
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className={`h-2 rounded-full transition-all ${
                    usageData.percentageUsed >= 90 ? 'bg-red-500' :
                    usageData.percentageUsed >= 75 ? 'bg-amber-500' :
                    'bg-green-500'
                  }`}
                  style={{ width: `${Math.min(usageData.percentageUsed, 100)}%` }}
                />
              </div>
              {usageData.percentageUsed >= 80 && usageData.limit !== -1 && (
                <p className="text-xs text-amber-600 mt-2">
                  ⚠️ You're approaching your monthly limit. Consider upgrading to avoid service interruption.
                </p>
              )}
            </div>

            {usageData.remaining !== undefined && usageData.limit !== -1 && (
              <div className="grid grid-cols-2 gap-4 pt-4 border-t">
                <div className="text-center">
                  <div className="text-2xl font-bold text-purple-600">{usageData.used}</div>
                  <div className="text-xs text-gray-500">Used</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600">{usageData.remaining}</div>
                  <div className="text-xs text-gray-500">Remaining</div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Action Buttons */}
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        <h3 className="text-md font-medium text-gray-900 mb-4">Manage Subscription</h3>
        
        <div className="space-y-3">
          {subscriptionStatus?.plan === 'FREE' ? (
            <a
              href="/pricing"
              className="w-full px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 text-center block font-medium"
            >
              Upgrade to Premium
            </a>
          ) : (
            <>
              <button
                onClick={handleOpenBillingPortal}
                className="w-full px-4 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center justify-center gap-2 font-medium"
              >
                <CreditCard className="h-4 w-4" />
                Manage Billing & Payment Methods
              </button>

              <a
                href="/pricing"
                className="w-full px-4 py-3 border border-purple-600 text-purple-600 rounded-lg hover:bg-purple-50 text-center block font-medium"
              >
                View All Plans & Upgrade
              </a>

              {subscriptionStatus?.cancelAtPeriodEnd ? (
                <button
                  onClick={handleReactivateSubscription}
                  className="w-full px-4 py-3 border border-green-600 text-green-600 rounded-lg hover:bg-green-50 font-medium"
                >
                  Reactivate Subscription
                </button>
              ) : (
                <button
                  onClick={handleCancelSubscription}
                  className="w-full px-4 py-3 border border-red-300 text-red-700 rounded-lg hover:bg-red-50 font-medium"
                >
                  Cancel Subscription
                </button>
              )}
            </>
          )}
        </div>
      </div>

      {/* Billing Portal Info */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-start gap-3">
          <AlertCircle className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div className="text-sm text-blue-800">
            <p className="font-medium mb-1">Stripe Customer Portal</p>
            <p>
              Update payment methods, view invoices, and download receipts through our secure billing portal powered by Stripe.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
      case 'autoresponse':
  return <AutoResponseSettings api={api} />;
      case 'general':
        return (
          <div className="space-y-6">
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Notifications</h2>
              <p className="text-sm text-gray-600 mb-6">
                Configure your notification preferences
              </p>
            </div>

            <div  style={{ display: 'none' }} className="bg-white border border-gray-200 rounded-lg p-6 space-y-6">
              <h3 className="text-md font-medium text-gray-900">Email Alerts</h3>
              
              <div className="space-y-4" >
                <label className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    checked={settings.newComplaintNotifications !== false}
                    onChange={(e) => setSettings({...settings, newComplaintNotifications: e.target.checked})}
                    className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300 rounded"
                  />
                  <div>
                    <span className="text-sm font-medium text-gray-900">New Ticket Alerts</span>
                    <p className="text-xs text-gray-500">Get notified immediately when new tickets arrive</p>
                  </div>
                </label>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-6">
              <h3 className="text-md font-medium text-gray-900">Weekly Reports</h3>

              <div className="space-y-4">
                <label className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    checked={settings.weeklyReports !== false}
                    onChange={(e) => setSettings({...settings, weeklyReports: e.target.checked})}
                    className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300 rounded"
                  />
                  <div>
                    <span className="text-sm font-medium text-gray-900">Weekly Reports</span>
                    <p className="text-xs text-gray-500">Receive weekly performance summaries via email</p>
                  </div>
                </label>
              </div>
            </div>

            {/* Blocked Senders */}
            <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-4">
              <div>
                <h3 className="text-md font-medium text-gray-900 flex items-center gap-2">
                  <Shield className="h-4 w-4 text-gray-400" />
                  Blocked Senders
                </h3>
                <p className="text-xs text-gray-500 mt-1">
                  Emails from blocked addresses or domains won't create tickets. Use <strong>@domain.com</strong> to block an entire domain, or <strong>email@example.com</strong> to block a specific address.
                </p>
              </div>

              <div className="flex gap-2">
                <input
                  type="text"
                  value={newBlockedEntry}
                  onChange={(e) => setNewBlockedEntry(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && addBlockedSender()}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-purple-500 text-sm"
                  placeholder="e.g. spam@example.com or @spammydomain.com"
                />
                <button
                  onClick={addBlockedSender}
                  disabled={!newBlockedEntry.trim() || savingBlockedSenders}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium flex items-center gap-1"
                >
                  <Plus className="h-4 w-4" />
                  Block
                </button>
              </div>

              {blockedSendersMessage && (
                <p className={`text-xs ${blockedSendersMessage.type === 'success' ? 'text-green-600' : 'text-red-600'}`}>
                  {blockedSendersMessage.text}
                </p>
              )}

              {blockedSenders.length > 0 ? (
                <div className="space-y-2">
                  {blockedSenders.map((entry) => (
                    <div key={entry} className="flex items-center justify-between bg-gray-50 px-3 py-2 rounded-lg">
                      <div className="flex items-center gap-2">
                        <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${
                          entry.startsWith('@') ? 'bg-red-100 text-red-700' : 'bg-orange-100 text-orange-700'
                        }`}>
                          {entry.startsWith('@') ? 'Domain' : 'Email'}
                        </span>
                        <span className="text-sm text-gray-900">{entry}</span>
                      </div>
                      <button
                        onClick={() => removeBlockedSender(entry)}
                        disabled={savingBlockedSenders}
                        className="text-gray-400 hover:text-red-500 transition-colors"
                      >
                        <X className="h-4 w-4" />
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-400 text-center py-3">No blocked senders yet</p>
              )}
            </div>
          </div>
        );

      case 'integrations':
        return (
          <div className="space-y-6">
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Integrations</h2>
              <p className="text-sm text-gray-600 mb-6">
                Connect your customer service tools and platforms to centralize all support requests
              </p>
            </div>

            {Object.entries(groupedIntegrations).map(([category, categoryIntegrations]) => (
              <div key={category} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
                  <h3 className="text-sm font-medium text-gray-900">{category}</h3>
                </div>
                
                <div className="divide-y divide-gray-200">
                  {categoryIntegrations.map((integration) => (
                <div key={integration.id} className="p-6 cursor-pointer hover:bg-gray-50 transition-colors"  onClick={() => integration.implemented && setActiveIntegrations(prev => ({
    ...prev,
    [integration.id]: !prev[integration.id]
  }))}
>
                      <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center space-x-4">
                          <div className={`w-12 h-12 rounded-lg flex items-center justify-center text-white ${integration.color}`}>
                            <integration.icon className="w-6 h-6" />
                          </div>
                          <div>
                            <h4 className="text-lg font-medium text-gray-900">{integration.name}</h4>
                            <p className="text-sm text-gray-500">{integration.description}</p>
                          </div>
                        </div>
                        <div className="flex items-center space-x-3">
                          {getStatusBadge(integration.status)}
                          {integration.implemented ? (
                            <button
               
                              className="text-purple-600 hover:text-purple-700 p-1"
                            >
                              <ChevronRight className={`w-4 h-4 transition-transform ${
                                activeIntegrations[integration.id] ? 'rotate-90' : ''
                              }`} />
                            </button>
                          ) : (
                            <Lock className="w-4 h-4 text-gray-400" />
                          )}
                        </div>
                      </div>
                      
                      {activeIntegrations[integration.id] && integration.implemented && (
                        <div className="mt-4 p-4 bg-gray-50 rounded-lg border"
                         onClick={(e) => e.stopPropagation()}>
                          {renderIntegrationDetails(integration)}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div className="flex items-start">
                <AlertTriangle className="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
                <div>
                  <h4 className="text-sm font-medium text-blue-900 mb-1">More Integrations Coming Soon</h4>
                  <p className="text-sm text-blue-800">
                    We're actively working on adding more integrations. Have a specific platform in mind? 
                    <a href="mailto:support@ticketdesk.app" className="font-medium underline ml-1">Let us know!</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        );

      case 'business':
        return (
          <div className="space-y-6">
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Business Hours</h2>
              <p className="text-sm text-gray-600 mb-6">
                Set your team's availability for handling customer tickets
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-md font-medium text-gray-900 flex items-center">
                  <CalendarIcon className="h-4 w-4 text-gray-400 mr-2" />
                  Weekly Schedule
                </h3>
                <button
                  onClick={applyToAllWeekdays}
                  className="text-sm text-purple-600 hover:text-purple-700"
                >
                  Apply Monday to all weekdays
                </button>
              </div>

              <div className="space-y-4">
                {days.map(day => {
                  const dayHours = businessHours[day] || { enabled: false, open: '09:00', close: '17:00' };
                  
                  return (
                    <div key={day} className="flex items-center space-x-4 py-2">
                      <div className="w-32">
                        <label className="flex items-center space-x-2">
                          <input
                            type="checkbox"
                            checked={dayHours.enabled}
                            onChange={() => handleDayToggle(day)}
                            className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300 rounded"
                          />
                          <span className="text-sm font-medium text-gray-700 capitalize">{day}</span>
                        </label>
                      </div>
                      
                      {dayHours.enabled && (
                        <>
                          <div className="flex items-center space-x-2">
                            <Clock className="h-4 w-4 text-gray-400" />
                            <input
                              type="time"
                              value={dayHours.open || '09:00'}
                              onChange={(e) => handleTimeChange(day, 'open', e.target.value)}
                              className="px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-purple-500"
                            />
                          </div>
                          <span className="text-gray-500">to</span>
                          <div>
                            <input
                              type="time"
                              value={dayHours.close || '17:00'}
                              onChange={(e) => handleTimeChange(day, 'close', e.target.value)}
                              className="px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-purple-500"
                            />
                          </div>
                        </>
                      )}
                      
                      {!dayHours.enabled && (
                        <span className="text-sm text-gray-500 italic">Closed</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
              <p className="text-sm text-purple-800">
                <strong>Note:</strong> Business hours are displayed in your selected timezone. 
                Customer tickets received outside of business hours will be queued for the next available time.
              </p>
            </div>
          </div>
        );

      case 'templates':
        return (
          <div className="space-y-6">
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Response Templates</h2>
              <p className="text-sm text-gray-600 mb-6">
                Create and manage templates for quick responses to common complaints
              </p>
            </div>

            {/* Template Variables Help */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <h4 className="text-sm font-semibold text-blue-900 mb-2">Available Template Variables</h4>
              <div className="grid grid-cols-2 gap-2 text-xs text-blue-800">
                <div>
                  <strong>Customer:</strong> {'{customerName}'}, {'{customerFirstName}'}, {'{customerEmail}'}
                </div>
                <div>
                  <strong>Agent:</strong> {'{agentName}'}, {'{agentFirstName}'}, {'{agentEmail}'}
                </div>
                <div>
                  <strong>Complaint:</strong> {'{subject}'}, {'{complaintId}'}, {'{category}'}
                </div>
                <div>
                  <strong>Date/Time:</strong> {'{currentDate}'}, {'{currentTime}'}
                </div>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg">
              <div className="p-4 border-b border-gray-200 flex items-center justify-between">
                <h3 className="text-md font-medium text-gray-900">Templates</h3>
                <button
                  onClick={() => setIsAddingNewTemplate(true)}
                  className="px-3 py-1.5 bg-purple-600 text-white text-sm rounded-md hover:bg-purple-700 flex items-center space-x-1"
                >
                  <Plus className="h-4 w-4" />
                  <span>Add Template</span>
                </button>
              </div>

              <div className="divide-y divide-gray-200">
                {isAddingNewTemplate && (
                  <div className="p-4 bg-purple-50">
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Template Name</label>
                        <input
                          type="text"
                          value={newTemplate.name}
                          onChange={(e) => setNewTemplate({ ...newTemplate, name: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-purple-500"
                          placeholder="e.g., Shipping Delay Response"
                        />
                      </div>
                      
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Template Content
                          <span className="ml-2 text-xs text-gray-500">Use variables like {'{customerFirstName}'} for personalization</span>
                        </label>
                        <textarea
                          value={newTemplate.content}
                          onChange={(e) => setNewTemplate({ ...newTemplate, content: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-purple-500 font-mono text-sm"
                          rows="6"
                          placeholder="Dear {customerFirstName},&#10;&#10;Thank you for contacting us regarding &quot;{subject}&quot;..."
                        />
                      </div>

                      <div className="flex justify-between">
                        <button
                          onClick={() => handleImproveTemplate(newTemplate)}
                          disabled={isImprovingTemplate || !newTemplate.content}
                          className="px-3 py-1.5 border border-purple-300 text-purple-700 rounded-md hover:bg-purple-50 text-sm flex items-center space-x-1 disabled:opacity-50"
                        >
                          {isImprovingTemplate ? (
                            <>
                              <RefreshCw className="h-4 w-4 animate-spin" />
                              <span>Improving...</span>
                            </>
                          ) : (
                            <>
                              <Sparkles className="h-4 w-4" />
                              <span>Improve with AI</span>
                            </>
                          )}
                        </button>
                        
                        <div className="flex space-x-2">
                          <button
                            onClick={() => {
                              setIsAddingNewTemplate(false);
                              setNewTemplate({ name: '', content: '' });
                            }}
                            className="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 text-sm"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => handleSaveTemplate(newTemplate)}
                            disabled={!newTemplate.name || !newTemplate.content}
                            className="px-3 py-1.5 bg-purple-600 text-white rounded-md hover:bg-purple-700 disabled:opacity-50 text-sm flex items-center space-x-1"
                          >
                            <Save className="h-4 w-4" />
                            <span>Save Template</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {templates.map((template) => (
                  <div key={template.id} className="p-4 hover:bg-gray-50">
                    {editingTemplate?.id === template.id ? (
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Template Name</label>
                          <input
                            type="text"
                            value={editingTemplate.name}
                            onChange={(e) => setEditingTemplate({ ...editingTemplate, name: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-purple-500"
                          />
                        </div>
                        
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Template Content
                            <span className="ml-2 text-xs text-gray-500">Use variables for personalization</span>
                          </label>
                          <textarea
                            value={editingTemplate.content}
                            onChange={(e) => setEditingTemplate({ ...editingTemplate, content: e.target.value })}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-purple-500 font-mono text-sm"
                            rows="8"
                          />
                        </div>
                        
                        <div className="flex justify-between">
                          <button
                            onClick={() => handleImproveTemplate(editingTemplate)}
                            disabled={isImprovingTemplate}
                            className="px-3 py-1.5 border border-purple-300 text-purple-700 rounded-md hover:bg-purple-50 text-sm flex items-center space-x-1 disabled:opacity-50"
                          >
                            {isImprovingTemplate ? (
                              <>
                                <RefreshCw className="h-4 w-4 animate-spin" />
                                <span>Improving...</span>
                              </>
                            ) : (
                              <>
                                <Sparkles className="h-4 w-4" />
                                <span>Improve with AI</span>
                              </>
                            )}
                          </button>
                          <div className="flex space-x-2">
                            <button
                              onClick={() => setEditingTemplate(null)}
                              className="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 text-sm"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={() => handleSaveTemplate(editingTemplate)}
                              className="px-3 py-1.5 bg-purple-600 text-white rounded-md hover:bg-purple-700 text-sm flex items-center space-x-1"
                            >
                              <Save className="h-4 w-4" />
                              <span>Save</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="flex items-center space-x-2 mb-2">
                            <FileText className="h-4 w-4 text-gray-400" />
                            <h4 className="text-sm font-medium text-gray-900">{template.name}</h4>
                            {template.isDefault && (
                              <span className="px-2 py-0.5 text-xs bg-blue-100 text-blue-600 rounded-full">
                                Default
                              </span>
                            )}
                          </div>
                          <p className="text-sm text-gray-600 line-clamp-3 whitespace-pre-wrap">{template.content}</p>
                        </div>
                        <div className="flex items-center space-x-2 ml-4">
                          <button
                            onClick={() => setEditingTemplate(template)}
                            className="p-1 text-gray-400 hover:text-purple-600"
                          >
                            <Edit2 className="h-4 w-4" />
                          </button>
                          {!template.isDefault && (
                            <button
                              onClick={() => handleDeleteTemplate(template.id)}
                              className="p-1 text-gray-400 hover:text-red-600"
                            >
                              <Trash2 className="h-4 w-4" />
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                ))}

                {templates.length === 0 && !isAddingNewTemplate && (
                  <div className="p-8 text-center">
                    <FileText className="h-12 w-12 text-gray-300 mx-auto mb-3" />
                    <p className="text-gray-500 mb-2">No templates yet</p>
                    <p className="text-sm text-gray-400">Create your first template to speed up responses</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        );

      case 'team':
        return (
          <div className="space-y-6">
            <div>
              <h2 className="text-lg font-semibold text-gray-900 mb-4">Team Management</h2>
              <p className="text-sm text-gray-600 mb-6">
                Manage your team members and send invitations
              </p>
            </div>

            {/* Team Members */}
            <div className="bg-white border border-gray-200 rounded-lg">
              <div className="p-4 border-b border-gray-200 flex items-center justify-between">
                <h3 className="text-md font-medium text-gray-900 flex items-center">
                  <Users className="h-4 w-4 text-gray-400 mr-2" />
                  Team Members ({teamMembers.length})
                </h3>
                {user?.role === 'ADMIN' && (
                  <button
                    onClick={() => setShowInviteModal(true)}
                    className="px-3 py-1.5 bg-purple-600 text-white text-sm rounded-md hover:bg-purple-700 flex items-center space-x-1"
                  >
                    <UserPlus className="h-4 w-4" />
                    <span>Invite Member</span>
                  </button>
                )}
              </div>

              <div className="divide-y divide-gray-200">
                {teamMembers.map((member) => (
                  <div key={member.id} className="p-4 hover:bg-gray-50">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                          <span className="text-purple-600 font-medium">
                            {member.name ? member.name.charAt(0).toUpperCase() : member.email.charAt(0).toUpperCase()}
                          </span>
                        </div>
                        <div>
                          <div className="flex items-center space-x-2">
                            <p className="text-sm font-medium text-gray-900">{member.name || 'No name'}</p>
                            <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${getRoleBadgeColor(member.role)}`}>
                              {member.role}
                            </span>
                            {member.id === user?.id && (
                              <span className="px-2 py-0.5 text-xs bg-gray-100 text-gray-600 rounded-full">You</span>
                            )}
                          </div>
                          <p className="text-sm text-gray-500">{member.email}</p>
                          {member.gmailConnected && (
                            <p className="text-xs text-green-600 mt-1 flex items-center">
                              <Mail className="h-3 w-3 mr-1" />
                              Gmail connected
                            </p>
                          )}
                        </div>
                      </div>
                      {user?.role === 'ADMIN' && member.id !== user?.id && (
                        <button
                          onClick={() => handleRemoveMember(member.id)}
                          className="p-1 text-gray-400 hover:text-red-600"
                        >
                          <X className="h-4 w-4" />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Pending Invitations */}
            {invitations.length > 0 && (
              <div className="bg-white border border-gray-200 rounded-lg">
                <div className="p-4 border-b border-gray-200">
                  <h3 className="text-md font-medium text-gray-900 flex items-center">
                    <Clock className="h-4 w-4 text-gray-400 mr-2" />
                    Pending Invitations ({invitations.filter(inv => inv.status === 'PENDING').length})
                  </h3>
                </div>

                <div className="divide-y divide-gray-200">
                  {invitations.filter(inv => inv.status === 'PENDING').map((invitation) => (
                    <div key={invitation.id} className="p-4 hover:bg-gray-50">
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="flex items-center space-x-2">
                            <p className="text-sm font-medium text-gray-900">{invitation.email}</p>
                            <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${getRoleBadgeColor(invitation.role)}`}>
                              {invitation.role}
                            </span>
                          </div>
                          {invitation.name && <p className="text-sm text-gray-500">Invited as: {invitation.name}</p>}
                          <p className="text-xs text-gray-400 mt-1">
                            Expires: {new Date(invitation.expiresAt).toLocaleDateString()}
                          </p>
                        </div>
                        {user?.role === 'ADMIN' && (
                          <div className="flex items-center space-x-2">
                            <button
                              onClick={() => handleResendInvite(invitation.id)}
                              className="text-sm text-purple-600 hover:text-purple-700"
                            >
                              Resend
                            </button>
                            <button
                              onClick={() => handleRevokeInvite(invitation.id)}
                              className="text-sm text-red-600 hover:text-red-700"
                            >
                              Revoke
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Invite Modal */}
            {showInviteModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 w-full max-w-md">
                  <h3 className="text-lg font-semibold mb-4">Invite Team Member</h3>
                  
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                      <input
                        type="email"
                        value={inviteData.email}
                        onChange={(e) => setInviteData({ ...inviteData, email: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-purple-500"
                        placeholder="colleague@company.com"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Name (Optional)</label>
                      <input
                        type="text"
                        value={inviteData.name}
                        onChange={(e) => setInviteData({ ...inviteData, name: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-purple-500"
                        placeholder="John Doe"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
                      <select
                        value={inviteData.role}
                        onChange={(e) => setInviteData({ ...inviteData, role: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-purple-500"
                      >
                        <option value="AGENT">Agent</option>
                     
                        <option value="ADMIN">Admin</option>
                      </select>
                      <p className="text-xs text-gray-500 mt-1">
                        {inviteData.role === 'ADMIN' && 'Full access to all features and settings'}
                        {inviteData.role === 'MANAGER' && 'Can manage complaints and view analytics'}
                        {inviteData.role === 'AGENT' && 'Can view and respond to complaints'}
                      </p>
                    </div>
                  </div>

                  <div className="flex justify-end space-x-2 mt-6">
                    <button
                      onClick={() => {
                        setShowInviteModal(false);
                        setInviteData({ email: '', role: 'AGENT', name: '' });
                      }}
                      className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleInvite}
                      disabled={!inviteData.email || inviteLoading}
                      className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 disabled:opacity-50"
                    >
                      {inviteLoading ? 'Sending...' : 'Send Invitation'}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
          {/* Local Notification Toast */}
    {localNotification && (
      <div className="fixed top-4 right-4 z-50 animate-slide-in">
        <div className={`px-4 py-3 rounded-lg shadow-lg ${
          localNotification.type === 'success' ? 'bg-green-600' : 
          localNotification.type === 'error' ? 'bg-red-600' : 
          'bg-blue-600'
        } text-white`}>
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">{localNotification.message}</span>
            <button onClick={() => setLocalNotification(null)} className="ml-2 hover:text-gray-200">
              ×
            </button>
          </div>
        </div>
      </div>
    )}
      {/* Header */}
      <div className="bg-white border-b sticky top-0 z-10">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={onBack}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                aria-label="Go back"
              >
                <ArrowLeft className="h-5 w-5 text-gray-600" />
              </button>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
                <p className="text-sm text-gray-500 mt-0.5">Manage your account and preferences</p>
              </div>
            </div>
            
            {/* Save Button - Only show for tabs that need saving */}
            {['general', 'business', 'templates'].includes(activeTab) && (
              <button
                onClick={saveSettings}
                disabled={saving}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 flex items-center space-x-2 transition-colors"
              >
                {saving ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    <span>Saving...</span>
                  </>
                ) : (
                  <>
                    <Save className="h-4 w-4" />
                    <span>Save Changes</span>
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Save Message */}
      {saveMessage && (
        <div className={`mx-6 mt-4 p-3 rounded-lg flex items-center space-x-2 ${
          saveMessage.type === 'success' 
            ? 'bg-green-50 border border-green-200 text-green-800'
            : 'bg-red-50 border border-red-200 text-red-800'
        }`}>
          {saveMessage.type === 'success' ? (
            <CheckCircle className="h-5 w-5 text-green-600" />
          ) : (
            <AlertCircle className="h-5 w-5 text-red-600" />
          )}
          <span className="text-sm font-medium">{saveMessage.text}</span>
        </div>
      )}

      <div className="flex h-[calc(100vh-80px)]">
        {/* Sidebar */}
        <div className="w-80 bg-white border-r border-gray-200 overflow-y-auto">
          <nav className="p-4 space-y-1">
            {tabs.map(tab => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`w-full text-left px-4 py-3 rounded-lg transition-all ${
                    isActive
                      ? 'bg-purple-50 border border-purple-200'
                      : 'hover:bg-gray-50'
                  }`}
                >
                  <div className="flex items-start space-x-3">
                    <div className={`mt-0.5 ${
                      isActive ? 'text-purple-600' : 'text-gray-400'
                    }`}>
                      <Icon className="h-5 w-5" />
                    </div>
                    <div className="flex-1">
                      <div className={`font-medium text-sm ${
                        isActive ? 'text-purple-900' : 'text-gray-900'
                      }`}>
                        {tab.label}
                      </div>
                      <div className={`text-xs mt-0.5 ${
                        isActive ? 'text-purple-600' : 'text-gray-500'
                      }`}>
                        {tab.description}
                      </div>
                    </div>
                    {isActive && (
                      <div className="mt-0.5">
                        <div className="w-1.5 h-1.5 bg-purple-600 rounded-full"></div>
                      </div>
                    )}
                  </div>
                </button>
              );
            })}
          </nav>

          {/* User Info Section at Bottom */}
          <div className="border-t border-gray-200 p-4 mt-auto">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                <span className="text-purple-600 font-medium">
                  {user?.name ? user.name.charAt(0).toUpperCase() : user?.email?.charAt(0).toUpperCase() || 'U'}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {user?.name || 'User'}
                </p>
                <p className="text-xs text-gray-500 truncate">
                  {user?.email || ''}
                </p>
                {user?.role && (
                  <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800 mt-1">
                    {user.role}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-y-auto">
          <div className="max-w-4xl mx-auto p-6">
            {renderTabContent()}
          </div>
        </div>
      </div>
            <FacebookDisconnectModal
        isOpen={showFacebookDisconnectModal}
        onClose={() => setShowFacebookDisconnectModal(false)}
        onConfirm={handleDisconnectFacebook}
        isLoading={facebookLoading}
        pageCount={facebookStatus?.pages?.length || 0}
      />
      <GmailDisconnectModal
        isOpen={showGmailDisconnectModal}
        onClose={() => setShowGmailDisconnectModal(false)}
        onConfirm={handleDisconnectGmailConfirm}
        isLoading={isDisconnecting}
      />
      <G2DisconnectModal
      isOpen={showG2DisconnectModal} 
      onClose={() => setShowG2DisconnectModal(false)}
      onConfirm={handleRemoveG2Product}
      isLoading={verifyingG2}
      reviewCount={g2ReviewCount}
    />
    <CapterraDisconnectModal
      isOpen={showCapterraDisconnectModal}
      onClose={() => setShowCapterraDisconnectModal(false)}
      onConfirm={handleRemoveCapterraProduct}
      isLoading={verifyingCapterra}
      reviewCount={capterraReviewCount}
    />
      <TrustpilotDisconnectModal
  isOpen={showTrustpilotDisconnectModal}
  onClose={() => setShowTrustpilotDisconnectModal(false)}
  onConfirm={handleRemoveTrustpilotDomain}
  isLoading={verifyingDomain}
  reviewCount={trustpilotReviewCount}
/>
      <WidgetEmbedModal
        isOpen={showWidgetModal}
        onClose={() => setShowWidgetModal(false)}
        apiKey={widgetStatus?.apiKey}
      />
    </div>
  );
};

export default SettingsPage;